import { Stack, Typography, Box, Divider, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatRelative } from 'date-fns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CloseIcon from '@mui/icons-material/Close';

type Props = { userAppInstance: any; onClose?: () => void };

const UserAppHeader = ({ userAppInstance = {}, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction={'row'}
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      className="glass-card-light"
      sx={{
        px: 1.5,
        py: 0.5,
        borderBottom: 'none',
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <AppRegistrationIcon color="primary" sx={{ opacity: 0.8 }} />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: '1rem' }}>
            {userAppInstance?.name}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.7, textTransform: 'uppercase', letterSpacing: 1 }}>
            {userAppInstance?.userAppDef?.name}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <Stack
          direction="row"
          spacing={3}
          divider={<Divider orientation="vertical" flexItem sx={{ height: 16, my: 'auto' }} />}
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          {userAppInstance?.createdDate && (
            <Stack direction="row" spacing={1} alignItems="center">
              <AccessTimeIcon sx={{ fontSize: 14, opacity: 0.6 }} />
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {t('common.created')}: {formatRelative(new Date(userAppInstance.createdDate), new Date())}
              </Typography>
              <PersonOutlineIcon sx={{ fontSize: 14, opacity: 0.6 }} />
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {userAppInstance.createdBy}
              </Typography>
            </Stack>
          )}
          {userAppInstance?.lastUpdatedDate && (
            <Stack direction="row" spacing={1} alignItems="center">
              <AccessTimeIcon sx={{ fontSize: 14, opacity: 0.6 }} />
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {t('common.updated')}: {formatRelative(new Date(userAppInstance.lastUpdatedDate), new Date())}
              </Typography>
              <PersonOutlineIcon sx={{ fontSize: 14, opacity: 0.6 }} />
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {userAppInstance.lastUpdatedBy}
              </Typography>
            </Stack>
          )}
        </Stack>

        {onClose && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={onClose}
            startIcon={<CloseIcon />}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', whiteSpace: 'nowrap' }}
          >
            {t('common.buttons.close')}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default UserAppHeader;

